import type { DocMigration } from "../docMigration";

const builtInFramingComponentsGroup = {
  entityType: "GROUP",
  name: "Built-in Framing",
  id: "builtInFramingComponentsGroup",
  isBuiltIn: true,
};

const builtInHeaderAssembliesGroup = {
  entityType: "GROUP",
  name: "Built-in Header Assemblies",
  id: "builtInHeaderAssembliesGroup",
  isBuiltIn: true,
};

const builtInFramingComponentsEntityGroups = {
  "framingComponent.default2x4": "builtInFramingComponentsGroup",
  "framingComponent.default2x6": "builtInFramingComponentsGroup",
  "framingComponent.default2x8": "builtInFramingComponentsGroup",
  "framingComponent.default2x10": "builtInFramingComponentsGroup",
  "framingComponent.default2x12": "builtInFramingComponentsGroup",
};

const builtInHeaderAssembliesEntityGroups = {
  "headerAssembly.HOUSE-HDR-AUTO-2x4-1": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x6-1": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x8-1": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x10-1": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x12-1": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x4-2": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x6-2": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x8-2": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x10-2": "builtInHeaderAssembliesGroup",
  "headerAssembly.HOUSE-HDR-AUTO-2x12-2": "builtInHeaderAssembliesGroup",
};

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_478: DocMigration = {
  maxSchemaVersion: "0.0.478",
  description: "Update doc with header, framing, and entity groups for built-in elements",
  apply(json: any) {
    const { groups = {}, entityGroups = {} } = json;

    let groupSortIndex = Object.keys(groups).length;

    const updatedGroups = {
      ...groups,
      [builtInFramingComponentsGroup.id]: { ...builtInFramingComponentsGroup, sortIndex: groupSortIndex++ },
      [builtInHeaderAssembliesGroup.id]: { ...builtInHeaderAssembliesGroup, sortIndex: groupSortIndex++ },
    };

    const updatedEntityGroups = {
      ...entityGroups,
      ...builtInFramingComponentsEntityGroups,
      ...builtInHeaderAssembliesEntityGroups,
    };

    return {
      ...json,
      groups: updatedGroups,
      entityGroups: updatedEntityGroups,
    };
  },
};

export default migration_0_0_478;
